import { configureStore } from "@reduxjs/toolkit";
import interfaceSlice from "./slices/interfaceSlice";

export default configureStore({
  reducer: {
    interface: interfaceSlice,
  },
});
